type pepOptionsType = {
  value: string;
  label: string;
};

const candidateTextFalsePep = 'Declaro que NÃO sou';
const guarantorTextFalsePep = 'Afirmo que esta pessoa NÃO é';
const candidateTextTruePep = 'Declaro que sou';
const guarantorTextTruePep = 'Afirmo que esta pessoa é';

const pepOptions = (isCadidate: boolean): pepOptionsType[] => [
  {
    value: 'false',
    label: `${
      isCadidate ? candidateTextFalsePep : guarantorTextFalsePep
    } uma Pessoa Politicamente Exposta.`,
  },
  {
    value: 'true',
    label: `${
      isCadidate ? candidateTextTruePep : guarantorTextTruePep
    } uma Pessoa Politicamente Exposta.`,
  },
];

export default pepOptions;
